module.exports = __webpack_public_path__ + "media/component-library/signup-form/images/google-icon-32c2adfe84a92470b6cade8fd12a9b34.svg";